const f = {
  bg: "linear-gradient(120deg, #ff5400 10%, #ffb700 157%)",
  border: "none",
  color: "#ffffff"
}, o = {
  bg: "#689d3e",
  border: "none",
  color: "#ffffff"
};
export {
  f,
  o as w
};
